module.exports = __webpack_public_path__ + "img/tangledeep-small.159ec118.jpg";